<script lang="typescript">
    export let text: string = "Body 2/Roboto/Regular/14px";
    export let color = "var(--color-level-8)";
</script>

<h1 style="color: {color};" class="body2">{text}</h1>

<style>
    .body2 {
        /* Body 2 */
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height, or 143% */
        letter-spacing: 0.25px;

        pointer-events: none;
    }
</style>
